export const PATH_EXPERT = '/expert';
export const PATH_LIGHT = '/light';
export const PATH_CALCULATE = '/calculate/:bd?/:ed?/:bdheb?/:bdhss?';
export const PATH_HELP = '/help';
export const PATH_SIGN_IN = '/signin';
export const PATH_ACCESS = '/access';
export const PATH_HOME = '/';